(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["general-page-heading"]) return;
  try {
    
  document.body.classList.add("general-template");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  jQuery(function($){
    $('#js-drawer-close').on('click', function(e) {
      e.preventDefault();
      $('.js-drawer-open-button-left').trigger('click');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuio-legal-detail-content-block"]) return;
  try {
    
  document.body.className += ' legal-details';
  let htmlEl = document.getElementsByTagName("html");
  htmlEl[0].className += " smooth-scroll";

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuio-legal"]) return;
  try {
    
  document.body.className += ' legal';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuio-support-faqs-section"]) return;
  try {
    
  document.body.className += ' support';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuio-user-guides-content-block"]) return;
  try {
    
  document.body.className += ' user-guides';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuio-user-guides-index"]) return;
  try {
    
  document.body.className += ' user-guides-index';

  } catch(e) { console.error(e); }
})();
})();
